module.exports = __webpack_public_path__ + "img/Ident-Process-1-mobile.7512f782.png";